module.exports = ".photo-space{\r\n    width:75px;\r\n    height: 70px;\r\n    border: 1px solid black;\r\n    border-radius: 50%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/employee-master/emp-master-form/emp-master-form.component.css
// module id = ./src/app/ultilities/employee-master/emp-master-form/emp-master-form.component.css
// module chunks = main